// SPDX-License-Identifier: Apache-2.0
import GirafeHTMLElement from '../../base/GirafeHTMLElement';

class PrototypeBannerComponent extends GirafeHTMLElement {
  templateUrl = './template.html';
  styleUrls = ['../../styles/common.css', './style.css'];

  public constructor() {
    super('prototype');
  }

  protected override connectedCallback() {
    super.connectedCallback();

    if (this.context.configManager.Config.branding.prototypeBanner) {
      this.render();
    } else {
      this.hide();
    }
  }
}

export default PrototypeBannerComponent;
